import { motion } from "framer-motion";
import burrowText from './../assets/images/Burrow/burrowText.jpg';
import burrowNextEventImg from './../assets/images/Events/halloween.jpeg';
import burrow from './../assets/pdf/burrowMenuAmerica.pdf'

export default function BurrowShowcase() {

  // Upcoming event details
  const upcomingEvent = {
    title: "BURROW",
    date: "Saturday 31st October - 7PM - LATE",
    description: "Burrow Social Club is Bringing you its 1st Halloween Party!",
    image: burrowNextEventImg,
    link: "https://www.skiddle.com/whats-on/Stourbridge/The-Fox-Inn-Stourton/The-Fox-Inn-Presents--Burrow-Halloween-Bash/42838033/"
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    exit: { opacity: 0, y: -20, transition: { duration: 0.6, ease: "easeInOut" } }
  };

  return (
    <section className="relative w-full bg-[#f5f3ef] py-16 sm:py-16 px-6 overflow-hidden">
      {/* Soft animated background shape */}
      <motion.div
        className="absolute w-72 h-72 bg-[#274a59]/10 rounded-full top-1/3 left-1/2 -translate-x-1/2 filter blur-3xl pointer-events-none"
        animate={{ x: [-20, 20, -20], y: [-10, 10, -10] }}
        transition={{ repeat: Infinity, duration: 25, ease: "linear" }}
      />

      <motion.div
        className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center gap-6"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
        variants={{
          hidden: {},
          visible: { transition: { staggerChildren: 0.15 } }
        }}
      >
        {/* Replace logo with burrowText */}
        <motion.img
          src={burrowText}
          alt="Burrow"
          className="w-48 sm:w-64 md:w-72 rounded-xl shadow-lg"
          variants={fadeUp}
        />

        {/* Name & Tagline */}
        <motion.p className="uppercase tracking-[0.2em] text-sm sm:text-base opacity-80" variants={fadeUp}>
          A Fox Social Club
        </motion.p>

        {/* Short Description */}
        <motion.p className="max-w-2xl sm:max-w-3xl text-base sm:text-lg md:text-xl opacity-80 mt-2" variants={fadeUp}>
          BURROW is a rotating social club experience blending street food, DJs, and a relaxed, immersive atmosphere. Eat, drink, and enjoy exclusive events.
        </motion.p>

        {/* Upcoming Event Teaser */}
        <motion.div
          className="mt-8 bg-white/70 backdrop-blur-md rounded-2xl p-6 max-w-xl w-full shadow-xl flex flex-col sm:flex-row items-center gap-4 sm:gap-6"
          variants={fadeUp}
        >
          {upcomingEvent.image && (
            <img
              src={upcomingEvent.image}
              alt={upcomingEvent.title}
              className="w-full sm:w-36 rounded-lg object-cover shadow-md"
            />
          )}
          <div className="flex-1 text-left">
            <h3 className="text-lg sm:text-xl md:text-2xl font-serif mb-1">{upcomingEvent.title}</h3>
            <p className="text-sm sm:text-base mb-2 opacity-80">{upcomingEvent.date}</p>
            <p className="text-sm sm:text-base opacity-70">{upcomingEvent.description}</p>
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.div>
          <motion.a
            href={burrow}
            className="mt-8 inline-block bg-[#5594af] text-white px-8 py-3 mx-2 rounded-full font-semibold hover:bg-[#1f3a44] transition text-base sm:text-lg"
            variants={fadeUp}
          >
            View Previous Menu
          </motion.a>
          <motion.a
            href={upcomingEvent.link}
            className="mt-8 inline-block bg-[#274a59] text-white px-8 py-3 mx-2 rounded-full font-semibold hover:bg-[#1f3a44] transition text-base sm:text-lg"
            variants={fadeUp}
          >
             Explore BURROW
          </motion.a>
        </motion.div>
      </motion.div>
    </section>
  );
}